



const useAntSearch = (props) => {


  const onChange = (e) => {
    props.getData(e.target.value)
  };

  return {
    onChange,
  };
};

export default useAntSearch;

